import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

// Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyAgd9DLjycyvT6_CnDfCK1fAiY2PZANkMc",
  authDomain: "way2driveschool.firebaseapp.com",
  projectId: "way2driveschool",
  storageBucket: "way2driveschool.firebasestorage.app",
  messagingSenderId: "3114212454",
  appId: "1:3114212454:web:12fb1ab718599d2e19e1a7",
  measurementId: "G-NFLK3SL8H7"
};

// Initialize Firebase
let app;
let auth;
let db;
let analytics;
let storage;

try {
  // Check if Firebase is already initialized
  if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
  } else {
    app = getApp();
  }
  
  // Initialize services
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
} catch (error) {
  console.error("Error initializing Firebase:", error);
}

export { app, auth, db, analytics, storage };
export const isDemoMode = false;
